// extracted by mini-css-extract-plugin
module.exports = {"design":"biography-module--design--3oT2l","designSlant":"biography-module--designSlant--2Ie5I"};